import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userService from "../services/userService";
import { message } from "utils/Funciones";
import jwtDecode from "jwt-decode"
import { verifyToken } from "utils/Funciones";
const userToken = localStorage.getItem('userToken')

const initialState = {
    isMutation: { success: false, error: false, loading: false, message: '', updated: false },
    userToken: verifyToken('userToken'),
    user: userToken ? jwtDecode(userToken) : null,
    data: [],
    dataByPage: [],
    totalRow: 0,
    totalPage: 0,
    totalStoreValue: 0
};

export const login = createAsyncThunk(
    "user/login/login",
    async (formData, thunkAPI) => {
        try {
            return await userService.login(formData);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const create = createAsyncThunk(
    "user/create",
    async (formData, thunkAPI) => {
        try {
            return await userService.create(formData);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const get = createAsyncThunk(
    "user/get",
    async (token, thunkAPI) => {
        try {
            return await userService.get(token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getById = createAsyncThunk(
    "user/getById",
    async (token, thunkAPI) => {
        try {
            return await userService.getById(token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPage = createAsyncThunk(
    "user/getByPage/bypage",
    async (query, thunkAPI) => {
        try {
            return await userService.getByPage(query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const update = createAsyncThunk(
    "user/update/user",
    async (formData, thunkAPI) => {
        try {
            return await userService.update(formData);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const del = createAsyncThunk(
    "user/del",
    async (data, thunkAPI) => {
        try {
            return await userService.del(data);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.isMutation = { success: false, error: false, loading: false, message: '', updated: false }
        },

        UPDATE_USER_FROM_SOCKET(state, action) {


        },
        LOGOUT(state, { payload }) {
            localStorage.removeItem(payload)
            if (payload === 'userToken') {
                state.userToken = null;
                state.user = null;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            // LOGIN
            .addCase(login.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(login.fulfilled, (state, action) => {
                message(action.payload.message, 'success', 5)
                state.isMutation.loading = false;
                state.userToken = action.payload.token;
                state.user = jwtDecode(action.payload.token);
                localStorage.setItem('userToken', action.payload.token);
            })
            .addCase(login.rejected, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.error = true;
            })
            // CREATE
            .addCase(create.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(create.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
                state.isMutation.message = action.payload.message;
            })
            .addCase(create.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            // GET
            .addCase(get.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(get.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.data = action.payload.data;
            })
            .addCase(get.rejected, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.message = action.payload;
            })
            // GET_BYPAGE
            .addCase(getByPage.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(getByPage.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.dataByPage = action.payload.data;
                state.totalPage = action.payload.totalPage;
                state.totalRow = action.payload.totalRow;
            })
            .addCase(getByPage.rejected, (state, action) => {
                console.log(action)
                state.isMutation.loading = false;
                state.isMutation.message = action.payload;
            })

            // UPDATE
            .addCase(update.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(update.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.message = action.payload.message;
                const newState = state.dataByPage.map((item) => {
                    if (item._id === action.payload.newStateData.newData._id) {
                        
                        return {
                            ...item,
                            name: action.payload.newStateData.newData.name,
                            dni: action.payload.newStateData.newData.dni,
                            direccion: action.payload.newStateData.newData.direccion,
                            salario_dia: action.payload.newStateData.newData.salario_dia,
                            email: action.payload.newStateData.newData.email,
                            photo: action.payload.newStateData.newData.photo,
                            autoridad: action.payload.newStateData.newData.autoridad,
                            turno: action.payload.newStateData.newData.turno,
                            bloqueado: action.payload.newStateData.newData.bloqueado,
                            last_update: action.payload.newStateData.newData.last_update,
                        }
                    }
                    return item
                })
                state.dataByPage = newState
                state.isMutation.updated = true;
            })
            .addCase(update.rejected, (state, action) => {
                state.isMutation.loading = false;
            })

            // DELETE
            .addCase(del.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(del.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
                state.isMutation.message = action.payload.message;
            })
            .addCase(del.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
    },
});

export const { UPDATE_USER_FROM_SOCKET, LOGOUT, SET_TO_DEFAULT_RESPONSE } = userSlice.actions;

export default userSlice.reducer;

